var originalSetItem = localStorage.setItem;
localStorage.setItem = function (key) {
  var event = new Event(key, { bubbles: true, composed: true });
  originalSetItem.apply(this, arguments);
  document.dispatchEvent(event);
};
